module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-wrapper"
  }, [_c('div', {
    staticClass: "loading-content"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "text-uppercase"
  }, [_vm._v("Requisição em andamento")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0f97ecc8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f97ecc8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/components/loading.vue
// module id = 388
// module chunks = 1